import styled, { css } from "styled-components";
import { boxshadowMediumStyle } from "../../../../../../shared-components/toyota/styles/utils/Dropshadows.styles";
import * as UscCashPriceStyles from "../../price/UscCashPrice.styles";

export const Button = styled.button`
    display: flex;
    position: relative;
    flex: 1 0 50%;
    flex-direction: column;
    align-items: flex-start;
    padding-inline: calc(var(--spacing-3) / 2);
    padding-block: calc(var(--spacing-1) / 2) var(--spacing-1);
    border: 0;
    border-radius: 4px;
    user-select: none;
    &[aria-pressed="true"] {
        color: var(--color-primary-black);
        background-color: var(--color-primary-white);
        ${boxshadowMediumStyle};
    }

    @supports not (padding-inline: 0) {
        padding-top: calc(var(--spacing-1) / 2);
        padding-bottom: var(--spacing-1);
        padding-left: calc(var(--spacing-3) / 2);
        padding-right: calc(var(--spacing-3) / 2);
    }
`;

export const Wrapper = styled.fieldset`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-1);
    align-self: stretch;
    padding: calc(var(--spacing-3) / 2);
    background-color: var(--color-grey-4);
    border-radius: 1.2rem;

    @supports not (padding-inline: 0) {
        width: 100%;
        & > div:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-1);
        }
    }
`;

export const ToggleWrapper = styled.div`
    display: flex;
    column-gap: calc(var(--spacing-3) / 2);
    align-self: stretch;
    justify-self: stretch;

    @supports not (gap: 0) {
        width: 100%;
        & label:not(:nth-last-child(1)) {
            margin-right: calc(var(--spacing-3) / 2);
        }
    }
`;

export const ToggleItem = styled.label`
    display: flex;
    position: relative;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    justify-content: space-between;
    row-gap: 0.2rem;
    width: 100%;
    margin: 0;
    padding: 0.4rem 3.2rem 0.8rem 1.2rem; /* added extra space to padding-right to preserve some space for the radio to avoid some overlap */
    border: 1px solid var(--color-grey-6);
    border-radius: 0.4rem;

    input {
        position: absolute;
        inset-block-start: 0.4rem;
        inset-inline-end: 0.8rem;
        width: 1.6rem;
        height: 1.6rem;
        opacity: 0;

        @supports not (inset: 0) {
            top: 0.4rem;
            right: 0.8rem;
        }
    }

    &:has(input) {
        width: 50%;
        cursor: pointer;

        &::before {
            display: block;
            position: absolute;
            inset-block-start: 0.4rem;
            inset-inline-end: 0.8rem;
            width: 1.6rem;
            height: 1.6rem;
            content: "";
            background-color: var(--color-primary-white);
            border: 1px solid var(--color-grey-6);
            border-radius: 50%;
        }
    }

    &:has(input:checked) {
        background-color: var(--color-primary-white);
        border-color: transparent;
        box-shadow: 0 0 8px 0 rgb(0 0 0 / 0.25);

        &::before {
            border-color: var(--color-primary-black);
        }
        &::after {
            display: block;
            position: absolute;
            inset-block-start: 0.8rem;
            inset-inline-end: 1.2rem;
            width: 0.8rem;
            height: 0.8rem;
            content: "";
            background-color: var(--color-primary-black);
            border: 1px solid var(--color-primary-black);
            border-radius: 50%;
        }
    }

    &:has(input:disabled) {
        &::before,
        &::after {
            display: none;
        }
    }

    &[data-testid="cash-only-toggle"] {
        cursor: default;
    }

    @supports not (row-gap: 0) {
        & span:first-of-type {
            margin-bottom: 0.2rem;
        }
    }

    @supports not (selector(:has(*))) {
        &[data-is-active="true"] {
            background-color: var(--color-primary-white);
            border-color: transparent;
            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);

            &::before {
                border-color: var(--color-primary-black);
            }
            &::after {
                display: block;
                position: absolute;
                top: 0.8rem;
                right: 1.2rem;
                width: 0.8rem;
                height: 0.8rem;
                content: "";
                background-color: var(--color-primary-black);
                border: 1px solid var(--color-primary-black);
                border-radius: 50%;
            }
        }

        &:not([data-testid="cash-only-toggle"]) {
            width: 50%;
            cursor: pointer;

            &::before {
                display: block;
                position: absolute;
                top: 0.4rem;
                right: 0.8rem;
                width: 1.6rem;
                height: 1.6rem;
                content: "";
                background-color: var(--color-primary-white);
                border: 1px solid var(--color-grey-6);
                border-radius: 50%;
            }
        }

        &[data-testid="cash-only-toggle"] {
            &::before,
            &::after {
                display: none;
            }
        }
    }
`;

export const ButtonTitle = styled.span<{ isLoading?: boolean }>`
    font-family: var(--font-semi-bold);
    font-size: 1.6rem;
    line-height: 2rem;

    ${({ isLoading }) =>
        isLoading &&
        css`
            color: var(--color-grey-7);

            ${UscCashPriceStyles.Cash} {
                color: var(--color-grey-7);
            }
        `};
`;

export const ButtonDescription = styled.span`
    &,
    & > span {
        font-family: var(--font-regular);
        font-size: 1.3rem;
        line-height: 2rem;
    }
`;

export const LoadingIconWrapper = styled.div`
    position: absolute;
    inset-block-end: 16px;
    inset-inline-end: 20px;

    @supports not (padding-inline: 0) {
        bottom: 16px;
        right: 20px;

        [dir="rtl"] & {
            left: 20px;
            right: auto;
        }
    }
`;
